import { render, staticRenderFns } from "./OpModal.vue?vue&type=template&id=461b3ca6&scoped=true&"
import script from "./OpModal.vue?vue&type=script&lang=js&"
export * from "./OpModal.vue?vue&type=script&lang=js&"
import style0 from "./OpModal.vue?vue&type=style&index=0&id=461b3ca6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461b3ca6",
  null
  
)

export default component.exports